
const validationRules = {
    name: value => {
        if (!value) {
            return 'Name is required';
        } else if (value.length > 50) {
            return 'Name must be less than 50 characters';
        } else if(value.trim().length === 0){
            return  "Name is not valid.";
        }
        return null;
    },
    email: value => {
        if (!value) {
            return 'Email is required';
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
            return 'Invalid email address';
        }
        return null;
    },

    loginEmail: value => {
        if (!value) {
            return 'Email is required';
        }
        return null;
    },

    loginPassword: value => {
        if (!value) {
            return 'Password is required';
        } else if (value.length > 32) {
            return 'Password cannot exceed 32 characters';
        }
        return null;
    },

    branchCode: value => {
        if (!value) {
            return 'Branch code is required';
        } else if (value.length > 10) {
            return "Branch code must be less than 10 characters"
        } else if(value.trim().length === 0){
            return  "Branch Code is not valid.";
        }
        return null;
    },
    branchName: value => {
        if (!value) {
            return 'Branch name is required';
        } else if (value.length > 50) {
            return 'Branch name must be less than 50 characters';
        } else if(value.trim().length === 0){
            return  "Branch Name is not valid.";
        }
        return null;
    },

    departmentCode: value => {
        if (!value) {
            return 'Department code is required';
        } else if (value.length > 10) {
            return "Department code must be less than 10 characters"
        } else if(value.trim().length === 0){
            return  "Department Code is not valid.";
        }
        return null;
    },
    departmentName: value => {
        if (!value) {
            return 'Department name is required';
        } else if (value.length > 50) {
            return 'Department name must be less than 50 characters';
        } else if(value.trim().length === 0){
            return  "Department Name is not valid.";
        }
        return null;
    },

    roleName: value => {
        if (!value) {
            return 'Role name is required';
        } else if (value.length > 50) {
            return 'Role name must be less than 50 characters';
        } else if(value.trim().length === 0){
            return  "Role Name is not valid.";
        }
        return null;
    },
    roleDescription: value => {
        if (value.length > 250) {
            return 'Role description must be less than 250 characters';
        }
        return null;
    },

    userRole: value => {
        if (!value) {
            return 'User role is required';
        }
        return null;
    },

    userMobile: value => {
        if (value) {
            // if (!/^\d+$/.test(value) || value.length < 10 || value.length > 13){
            //     return 'Mobile number validation failes'
            // }
            if (!/^\d+$/.test(value)) {
                return 'Mobile number must contain only numbers.'
            }
            if (value.length < 9 || value.length > 15) {
                return 'Mobile number must be between 9 and 15 digits.'
            }
        }
    },

    committeeType: value => {
        if (!value) {
            return 'Committee type is required';
        } else if (value.length > 50) {
            return 'Committee type must be less than 50 characters';
        } else if(value.trim().length === 0){
            return  "Committee Type is not valid.";
        }
        return null;
    },
    committeeDescription: value => {
        if (value.length > 250) {
            return 'Committee description must be less than 250 characters';
        }
        return null;
    },

    password: value => {
        if (!value) {
            return 'Password is required';
        }
        if (!/[A-Z]/.test(value)) {
            return 'Password must be at least 1 uppercase character';
        }
        if (!/[a-z]/.test(value)) {
            return 'Password must be at least 1 lowercase character';
        }
        if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) {
            return 'Password must be at least 1 special character';
        }
        if (!/[0-9]/.test(value)) {
            return 'Password must be at least 1 numeric character';
        }
        if (value.length < 8) {
            return 'Password must be at least 8 characters';
        }
        if (value.length > 32) {
            return 'Password must be have maximum 32 characters';
        }
        // if (/(\w)\1{1,}/.test(value)) {
        //     return 'New password cannot have more than 2 sequential characters.';
        // }
        if (hasSequentialChars(value)) {
            return 'New password cannot have sequential characters like "abc", "123", "xyz".';     
        }
        return null;
    },
    
    confirmPassword: (value, inputs) => {
        if (!value) {
            return 'Confirm password is required';
        } else if (value !== inputs.password) {
            return 'Passwords do not match';
        }
        return null;
    },
    companyName: value => {
        if (!value) {
            return 'Company Name is required';
        } else if (value.length > 100) {
            return "Company Name must be less than 100 characters"
        }
        return null;
    },
    companyAddress: value => {
        if (!value) {
            return 'Company Address is required';
        } else if (value.length > 250) {
            return "Company Address must be less than 250 characters"
        }
        return null;
    },
    companyPhone: value => {
        if (!value) {
            return 'Company Phone Number is required';
        } else if (isNaN(value)) {
            return 'Company Phone number should only contain numbers'
        }
        return null;
    },
    code: value => {
        if (!value) {
            return 'Code is required';
        } else if (value.length > 10) {
            return "Code must be less than 10 characters"
        }
        return null;
    },
    description: value => {
        // if (!value) {
        //     return 'Description is required';
        // } 
        if (value.length > 255) {
            return 'Description must be less than 255 characters';
        }
        return null;
    },
    role: value => {
        if (!value) {
            return 'Role is required';
        }
        return null;
    },
    address: value => {
        if (value.length > 255) {
            return 'Address must be less than 255 characters';
        }
        return null;
    },
    designation: value => {
        if (value.length > 50) {
            return 'Designation must be less than 50 characters';
        } else if(value.length > 0 && value.trim().length === 0){
            return "Designation is not valid.";
        }
        return null;
    },

    committeeName: value => {
        if (!value) {
            return 'Committee name is required';
        } else if (value.length > 50) {
            return "Committee name must be less than 50 characters"
        }
        return null;
    },
    committeeTypeDropDown: value => {
        if (!value) {
            return 'Committee type is required';
        }
        return null;
    },
    committeeSecretaryDropDown: value => {
        if (!value) {
            return 'Secretary is required';
        }
        return null;
    },
    committeeAssistantSecDown: value => {
        if (!value) {
            return 'Assistant secretary is required';
        }
        return null;
    },
    passwordExpirePeriod: value => {
        if (!value && value !== 0) {
            return 'Password expire period is required';
        } else if (isNaN(value)) {
            return 'Password expire period must be a number';
        } else if (value < 0) {
            return 'Password expire period cannot be negative';
        } else if (value < 42 || value > 90) {
            return 'Password expire period must be between 42 and 90 days';
        }
        return null;
    },
    paperCategoryName: value => {
        if (!value) {
            return 'Paper category name is required';
        }
        else if (value.length > 100) {
            return 'Paper category name must be less than 100 characters'
        }
        return null;
    },
    paperCategoryOrder: value => {
        if (!value && value !== 0) {
            return 'Order is required';
        } 
        // else if (value < 1 || value > 100) {
        //     return 'Order number must be between 1 and 100';
        // }
        return null;
    },

};

function hasSequentialChars(value) {
    for (let i = 0; i < value.length - 2; i++) {
        const first = value.charCodeAt(i);
        const second = value.charCodeAt(i + 1);
        const third = value.charCodeAt(i + 2);
        if (
        second === first + 1 &&
        third === second + 1
        ) {
        return true;
        }
        else  if (
        second === first - 1 &&
        third === second - 1
        ) {
        return true;
        }
    }
    return false;
    }

export default validationRules

